export const apiPath = '/v2/travel_forms';
const actionType = 'TRAVEL_FORMS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
